import { render, staticRenderFns } from "./AlignerSoftware.vue?vue&type=template&id=2443a207"
import script from "./AlignerSoftware.vue?vue&type=script&lang=js"
export * from "./AlignerSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports